module.exports = __webpack_public_path__ + "static/media/settings.41ee2157.gif";